module.exports = __webpack_public_path__ + "img/logo.b124068d.png";